import {
  GET_AGILE_PURCHASE_TRADED_PROVIDERS,
  GET_AGILE_PURCHASE_TRADED_PROVIDERS_SUCCESS,
  GET_AGILE_PURCHASE_TRADED_PROVIDERS_ERROR
} from './AgilePurchaseTradedProviders.actions'

const initialState = {
  csv: [],
  data: [],
  error: null,
  loading: false
}
/**
 * Agile Purchase Traded Providers's reducer.
 */
const agilePurchaseTradedProvidersReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case GET_AGILE_PURCHASE_TRADED_PROVIDERS:
      return { ...state, loading: true }
    case GET_AGILE_PURCHASE_TRADED_PROVIDERS_ERROR:
      return { ...state, loading: false, error: payload.error, categories: [], csv: [], data: [] }
    case GET_AGILE_PURCHASE_TRADED_PROVIDERS_SUCCESS:
      return {
        ...state,
        csv: payload.csv,
        data: payload.data,
        loading: false
      }
    default:
      return state
  }
}

export default agilePurchaseTradedProvidersReducer
